// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"40":"e82996df","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"40":"dbee9ab4a2efc9726608","245":"42fbc038e6993f02e564","453":"1d74a46add9fae0577da"}[chunkId] + ".js";
};